import { useState } from "react";
import { Button } from "../ui/button";
import { NotificationSettings } from "./NotificationSettings";
import { CategoryPreferences, ALL_CATEGORIES } from "./CategoryPreferences";
import { getTextPrimary, getTextSecondary } from "../../lib/styleHelpers";

export function SettingsTab({ settings, updateSettings, savingSettings, onTestWhatsApp, isDark }) {
  const [email, setEmail] = useState(settings?.notification_email || "");
  const [emailEnabled, setEmailEnabled] = useState(settings?.email_notifications || false);
  const [notificationTime, setNotificationTime] = useState(settings?.notification_time || "08:00");
  const [whatsappEnabled, setWhatsappEnabled] = useState(settings?.whatsapp_notifications || false);
  const [whatsappNumber, setWhatsappNumber] = useState(settings?.whatsapp_number || "");
  const [preferredCategories, setPreferredCategories] = useState(
    settings?.preferred_categories || ALL_CATEGORIES
  );

  const handleSave = () => {
    updateSettings({
      email_notifications: emailEnabled,
      notification_email: email,
      notification_time: notificationTime,
      whatsapp_notifications: whatsappEnabled,
      whatsapp_number: whatsappNumber,
      preferred_categories: preferredCategories,
    });
  };

  const cardClass = `rounded-xl p-6 border ${isDark ? "bg-[#12121a] border-white/10" : "bg-white border-gray-200"}`;

  return (
    <div className="max-w-2xl animate-fade-in space-y-6" data-testid="settings-content">
      {/* Notifications */}
      <div className={cardClass}>
        <h2 className={`text-lg font-bold mb-6 ${getTextPrimary(isDark)}`}>Notifications</h2>
        <NotificationSettings
          emailEnabled={emailEnabled}
          setEmailEnabled={setEmailEnabled}
          email={email}
          setEmail={setEmail}
          notificationTime={notificationTime}
          setNotificationTime={setNotificationTime}
          whatsappEnabled={whatsappEnabled}
          setWhatsappEnabled={setWhatsappEnabled}
          whatsappNumber={whatsappNumber}
          setWhatsappNumber={setWhatsappNumber}
          onTestWhatsApp={onTestWhatsApp}
          isDark={isDark}
        />
      </div>

      {/* Categories */}
      <div className={cardClass}>
        <CategoryPreferences
          preferredCategories={preferredCategories}
          setPreferredCategories={setPreferredCategories}
          isDark={isDark}
        />
      </div>

      {/* Save */}
      <div className={`${cardClass} flex items-center justify-between`}>
        <p className={`text-sm font-body ${getTextSecondary(isDark)}`}>Save all your preferences</p>
        <Button
          onClick={handleSave}
          disabled={savingSettings}
          className="bg-purple-600 hover:bg-purple-700 text-white rounded-full"
          data-testid="save-settings-btn"
        >
          {savingSettings ? "Saving..." : "Save Settings"}
        </Button>
      </div>

      {/* About */}
      <div className={`p-4 rounded-lg border ${isDark ? "bg-[#0c0c16] border-white/10" : "bg-gray-50 border-gray-200"}`}>
        <h3 className={`font-bold mb-2 ${getTextPrimary(isDark)}`}>About MyQairo</h3>
        <p className={`text-sm font-body ${isDark ? "text-gray-400" : "text-gray-600"}`}>
          MyQairo uses GPT-5.2 to analyze global market data, economic indicators,
          and business intelligence to identify high-probability arbitrage opportunities
          daily. Each opportunity is evaluated for execution feasibility across USA, UK,
          UAE, and Africa.
        </p>
      </div>
    </div>
  );
}
